define.alias("ember-math-helpers/helpers/pow", "media/helpers/pow");